/**
 * is a browser an Internet Explorer
 * @return {boolean}
 */
function isIE() {
    return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident') !== -1;
}

angular.module('storefrontApp')
    .controller('ieController', ['$scope', function ($scope) {
        $scope.iEModalVisible = isIE() && (!localStorage || !localStorage.getItem('IsIEHintShown'));
        $scope.closeIEModal = function () {
            $scope.iEModalVisible = false;
            if (localStorage) {
                localStorage.setItem('IsIEHintShown', true);
            }
        };
    }]);
